import styled, { css } from 'styled-components';

import LiquidIDCube from '@app/pages/Prototype/LiquidIDSection/LiquidIDCanvas';

// When changing this value you will have to manually change
// the css variable `--yat-dashboard-top-bar-height-new-navigation`
export const MAIN_NAVIGATION_DESKTOP_HEIGHT = 100;

export const MainNavigationContainer = styled.div`
    position: relative;
    height: ${MAIN_NAVIGATION_DESKTOP_HEIGHT}px;
    width: 100%;
    padding: 30px 20px 0;
    box-sizing: border-box;

    @media (min-width: 1563px) {
        padding: 30px 60px 0;
    }
`;

export const MainNavigationGrid = styled.div`
    display: grid;
    place-items: center;
    grid-template-columns: 3fr 1fr 3fr;
`;
export const ButtonsWrapper = styled.nav`
    justify-self: center;
    display: flex;
`;

export const ActionsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-self: end;
    justify-content: center;
`;

export const ActionButtonWrapper = styled.div`
    margin-left: 10px;
    &:first-child {
        margin-left: 0;
    }
`;

type LiquidIdWrapperProps = {
    $absolutePositioned?: boolean;
    $isYativerse?: boolean;
};

export const LiquidIdWrapper = styled(LiquidIDCube)<LiquidIdWrapperProps>`
    ${({ $absolutePositioned, $isYativerse }) =>
        $absolutePositioned
            ? css`
                  position: absolute;
                  top: 60%;
                  width: 150px;
                  margin-right: auto;
                  transform: translate(-25%, -50%);

                  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
                      top: 55%;
                  }
              `
            : css`
                  position: fixed;
                  width: 150px;
                  top: 0;
                  left: -12px;

                  @media (min-width: ${(props) => props.theme.breakpoints.desktopSmall}) {
                      left: 16px;
                  }

                  ${$isYativerse &&
                  css`
                      @media (min-width: ${(props) => props.theme.breakpoints.desktopSmall}) {
                          left: -14px;
                      }
                  `}
              `}
`;

interface SearchWrapperProps {
    $hasLiquidId?: boolean;
}
export const SearchWrapper = styled.div<SearchWrapperProps>`
    justify-self: start;
    ${({ $hasLiquidId }) =>
        $hasLiquidId
            ? css`
                  padding-left: 130px;
                  @media (max-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
                      padding-left: 90px;
                  }
                  @media (min-width: 1563px) {
                      padding-left: 160px;
                  }
              `
            : css`
                  padding-left: 80px;
              `}
`;

export const EditButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    justify-self: start;
`;

export const TopButtonsMobile = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 20px;
    left: 0;
    padding: 0 20px;
    width: 100%;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const NotificationDot = styled.div`
    position: absolute;
    top: -8px;
    right: -6px;

    width: 9px;
    height: 9px;

    background: #ee0a4a;

    border-radius: 100%;

    pointer-events: none;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        top: -3px;
        right: 0;

        width: 12px;
        height: 12px;
    }
`;
